import { ChakraFlex, SkeletonLoader } from '@equip.health/ui';
import { SurveyName } from '~/lib/constants/survey/SurveyName';
import { useGetGroupedAssessmentsQuery } from '~/store/services/assessments';
import { TreatmentOverviewCardDocumentButton } from './TreatmentOverviewCardDocumentButton';
import { Dispatch } from 'react';
import { AssessmentAction } from '~/lib/constants/patients.constants';

type Props = {
  patientId: string;
  updateAssessmentState: Dispatch<AssessmentAction>;
};

export const TreatmentOverviewCardDocumentsSection = ({
  patientId,
  updateAssessmentState,
}: Props) => {
  const {
    data: groupedAssessments,
    isLoading: isGetGroupedAssessmentsLoading,
  } = useGetGroupedAssessmentsQuery({ patientId });

  if (isGetGroupedAssessmentsLoading || !groupedAssessments) {
    return (
      <SkeletonLoader
        height="64px"
        id="treatment-overview-documents-loading"
        width="314px"
      />
    );
  }

  return (
    <ChakraFlex gap="12px" justifyContent="space-between" marginTop="16px">
      <TreatmentOverviewCardDocumentButton
        groupedAssessments={groupedAssessments}
        patientId={patientId}
        surveyName={SurveyName.SAFETY_PLAN}
        updateAssessmentState={updateAssessmentState}
      />
      <TreatmentOverviewCardDocumentButton
        groupedAssessments={groupedAssessments}
        patientId={patientId}
        surveyName={SurveyName.LETHAL_MEANS}
        updateAssessmentState={updateAssessmentState}
      />
    </ChakraFlex>
  );
};
